import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Icon } from '../icon';
import { NavButton, SliderWrapper } from './styled';
export const Slider = ({ slideData, passedSlide, onSlideChange, onNextSlide, onPrevSlide, iconSize = 'large', ...props }) => {
    const [currentSlide, setCurrentSlide] = useState(() => passedSlide || 0);
    const totalSlides = useMemo(() => slideData.length, [slideData]);
    const prevHandler = useCallback(() => {
        onPrevSlide && onPrevSlide();
        setCurrentSlide((prevState) => prevState - 1);
    }, [onPrevSlide]);
    const nextHandler = useCallback(() => {
        onNextSlide && onNextSlide();
        setCurrentSlide((prevState) => prevState + 1);
    }, [onNextSlide]);
    useEffect(() => {
        if (typeof passedSlide !== 'number')
            return;
        const roundedSlide = Math.floor(passedSlide);
        if (roundedSlide < 0)
            setCurrentSlide(0);
        else if (roundedSlide >= totalSlides)
            setCurrentSlide(totalSlides - 1);
        else if (roundedSlide !== currentSlide)
            setCurrentSlide(roundedSlide);
    }, [passedSlide]);
    useEffect(() => {
        onSlideChange && onSlideChange();
    }, [currentSlide, onSlideChange]);
    return (React.createElement(SliderWrapper, { ...props },
        totalSlides > 1 && (React.createElement(NavButton, { "aria-label": "Previous", onClick: prevHandler, "$isVisible": currentSlide !== 0 },
            React.createElement(Icon, { name: "arrow_back", size: iconSize }))),
        slideData[currentSlide],
        totalSlides > 1 && (React.createElement(NavButton, { "aria-label": "Next", onClick: nextHandler, "$isVisible": totalSlides > 1 && currentSlide < totalSlides - 1 },
            React.createElement(Icon, { name: "arrow_forward", size: iconSize })))));
};
